module.exports = __webpack_public_path__ + "website/img/Yoyo_C_04.e64e4730.jpeg";